import { createFileRoute, redirect } from "@tanstack/react-router";

// Overlaps /learn/how-does-saint-tms-work — consolidated there.
// Edge 301 is mirrored in public/_redirects.
export const Route = createFileRoute("/how-saint-works")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "how-does-saint-tms-work" },
      statusCode: 301,
    });
  },
});
